module.exports = __webpack_public_path__ + "media/src/images/icons/paragraph-f8d25a9e02895dd8da4fe0dfe77e15fa.svg";